import axios from "axios"

var componentRequireContext = require.context("components", true)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)

const csrfToken = document.querySelector("meta[name=csrf-token]").content
axios.defaults.headers.common["X-CSRF-Token"] = csrfToken